import { render, staticRenderFns } from "./sendtextglobal.vue?vue&type=template&id=5c74b2f4&scoped=true&"
import script from "./sendtextglobal.vue?vue&type=script&lang=js&"
export * from "./sendtextglobal.vue?vue&type=script&lang=js&"
import style0 from "./sendtextglobal.vue?vue&type=style&index=0&id=5c74b2f4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c74b2f4",
  null
  
)

export default component.exports